import { API_META_UPDATE, API_META_RESET } from 'actions/apiPaginationMeta';

import { generateKey } from 'constants/helper';

export const apiPaginationMetaInitialState = {
  limit: 4,
  offset: 0,
  hasMore: true,
  paginationKey: '',
};

export const getApiPaginationMetaInitialState = () => ({
  limit: 4,
  offset: 0,
  hasMore: true,
  paginationKey: generateKey(8),
});

const apiPaginationMetaReducer = (state = apiPaginationMetaInitialState, action) => {
  switch (action.type) {
    case API_META_UPDATE:
      return { ...state, ...action.payload };
    case API_META_RESET:
      return { ...state, ...apiPaginationMetaInitialState, paginationKey: generateKey(8) };
    default:
      return state;
  }
};

export default apiPaginationMetaReducer;
